<!-- @format -->

@if (customCourseUnitAttainment(); as customCourseUnitAttainment) {
  <sis-study-box
    [type]="StudyBoxType.customAttainment"
    [id]="customCourseUnitAttainment.id"
    [name]="customCourseUnitAttainment.name"
    [code]="customCourseUnitAttainment.code"
    [credits]="{ min: customCourseUnitAttainment.credits, max: customCourseUnitAttainment.credits }"
    [level]="headingLevel()"
    [attainedCredits]="customCourseUnitAttainment.credits"
    [gradeId]="customCourseUnitAttainment.gradeId"
    [gradeScaleId]="customCourseUnitAttainment.gradeScaleId"
    (nameClickAction)="openCustomAttainmentCreditInfoModal(customCourseUnitAttainment)" />
}
